import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceEquipamento = {
  ...serviceReutils({ name: 'rotas/v1/equipamento', api }),
};
